import React, { useState, useEffect } from "react";
import { Routes, Route, Link } from "react-router-dom";
import Startseite from "./components/Startseite.js";
import Probedaten from "./components/Probedaten.js";
import Ensemble from "./components/Ensemble.js";
import Figuren from "./components/Figuren.js";
import Zuordnung from "./components/Zuordnung.js";
import Szenen from "./components/Szenen.js";
import Absenzen from "./components/Absenzen.js";
import Team from "./components/Team.js";
import SzenenvorschlagPage from "./components/SzenenvorschlagPage.js";
import logo from './images/logo.png';

console.log("✅ App.js wird ausgeführt!");
console.log("✅ React-App gestartet!");

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("❌ React Fehler:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1 className="text-red-500">Fehler in der Anwendung: {this.state.error?.message}</h1>;
    }
    return this.props.children;
  }
}

function App() {
  const [currentProject, setCurrentProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    try {
      const savedProjects = JSON.parse(localStorage.getItem("projects")) || [];
      setProjects(savedProjects);

      const savedCurrentProject = JSON.parse(localStorage.getItem("currentProject"));
      if (savedCurrentProject) {
        setCurrentProject(savedCurrentProject);
      }
    } catch (error) {
      console.error("Fehler beim Laden der initialen Daten:", error);
    }
  }, []);

  useEffect(() => {
    if (projects.length > 0) {
      try {
        localStorage.setItem("projects", JSON.stringify(projects));
      } catch (error) {
        console.error("Fehler beim Speichern der Projekte:", error);
      }
    }
  }, [projects]);

  useEffect(() => {
    if (currentProject) {
      try {
        localStorage.setItem("currentProject", JSON.stringify(currentProject));
      } catch (error) {
        console.error("Fehler beim Speichern des aktuellen Projekts:", error);
      }
    }
  }, [currentProject]);

  const navigationItems = [
    { path: "/", label: "Startseite" },
    { path: "/probedaten", label: "Probedaten" },
    { path: "/ensemble", label: "Ensemble" },
    { path: "/figuren", label: "Figuren" },
    { path: "/zuordnung", label: "Zuordnung" },
    { path: "/szenen", label: "Szenen" },
    { path: "/absenzen", label: "Absenzen" },
    { path: "/team", label: "Team" },
    { path: "/szenenvorschlag", label: "Szenenvorschlag" }
  ];

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <ErrorBoundary>
      <div className="flex flex-col md:flex-row min-h-screen">
        {/* Mobile Menu Button */}
        <button
          onClick={toggleSidebar}
          className="md:hidden fixed top-4 left-4 z-50 bg-blue-500 text-white p-2 rounded"
        >
          {isSidebarOpen ? "✕" : "☰"}
        </button>

        {/* Sidebar - SCHMALER! */}
        <div
          className={`
            fixed md:static top-0 left-0 
            w-48 bg-gray-200 h-screen p-3 overflow-y-auto flex-shrink-0
            transform transition-transform duration-300 ease-in-out md:transform-none
            ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            md:translate-x-0
            z-40
          `}
        >
          <div className="flex flex-col items-center mb-4">
            <img src={logo} alt="Logo" className="w-20 mb-2" />
            <h1 className="text-lg font-bold text-center">Probeplaner</h1>
          </div>
          <nav>
            <ul>
              {navigationItems.map(({ path, label }) => (
                <li key={path} className="mb-1">
                  <Link 
                    to={path} 
                    className="block p-2 bg-blue-500 text-white rounded hover:bg-blue-700 text-sm text-center"
                    onClick={() => setIsSidebarOpen(false)}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Overlay für Mobile */}
        {isSidebarOpen && (
          <div
            className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}

        {/* Main Content */}
        <div className="flex-grow p-4 md:p-6 w-full overflow-x-hidden">
          {currentProject ? (
            <h2 className="text-xl font-bold mb-4">
              Aktuelles Projekt: {currentProject.name}
            </h2>
          ) : (
            <h2 className="text-red-500">
              ⚠ Kein aktuelles Projekt ausgewählt
            </h2>
          )}
          <Routes>
            <Route 
              path="/" 
              element={
                <Startseite 
                  currentProject={currentProject}
                  setCurrentProject={setCurrentProject}
                  projects={projects}
                  setProjects={setProjects}
                />
              } 
            />
            <Route path="/probedaten" element={<Probedaten projectId={currentProject?.id} />} />
            <Route path="/ensemble" element={<Ensemble projectId={currentProject?.id} />} />
            <Route path="/figuren" element={<Figuren projectId={currentProject?.id} />} />
            <Route path="/zuordnung" element={<Zuordnung projectId={currentProject?.id} />} />
            <Route path="/szenen" element={<Szenen projectId={currentProject?.id} />} />
            <Route path="/absenzen" element={<Absenzen projectId={currentProject?.id} />} />
            <Route path="/team" element={<Team projectId={currentProject?.id} />} />
            <Route path="/szenenvorschlag" element={<SzenenvorschlagPage projectId={currentProject?.id} />} />
          </Routes>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default App;
